export default __webpack_public_path__ + "static/media/2500_it.88bdb10a.ods";